<div class="phx-split-button-wrapper">
  <button phx-button
    class="phx-split-button-left"
    [disabled]="disabled"
    [phxLoading]="phxLoading"
    [phxSize]="phxSize"
    [phxButtonRole]="phxButtonRole"
    [phxButtonType]="phxButtonType"
    [phxBackground]="phxBackground"
    [phxPrefixIcon]="phxPrefixIcon"
    [phxHasShadow]="phxHasShadow"
    (phxOnClick)="handleClick($event)">
      <ng-content></ng-content>
  </button>
  <phx-menu-button
    class="phx-split-button-right"
    [disabled]="disabled"
    [phxSize]="phxSize"
    [phxButtonRole]="phxButtonRole"
    [phxButtonType]="phxButtonType"
    [phxBackground]="phxBackground"
    [phxDropdownTemplate]="phxDropdownTemplate"
    [phxDropdownPosition]="phxDropdownPosition"
    [phxHasShadow]="phxHasShadow"
    [phxDisableInteractions]="phxLoading"></phx-menu-button>
</div>
